import { Component, ViewChild } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { Content, DeepLinker, NavController, NavParams, ViewController } from "ionic-angular";
import { LoginRequired } from "../../decorators/login.required";
import { UserGroupService } from "../../services/user-group.service";
import { User, ViewDidEnter } from "../../app/app.interfaces";
import { EventService } from "../../services/event.service";
import { PostListContainer } from "../../partials/post/post-list-container/post-list-container";
import { PageTitleService } from "../../services/page-title.service";
import { NavigationHelper } from "../../helpers/navigation.helper";
import { IonicHelper } from "../../helpers/ionic.helper";
import { Subscription } from "rxjs/Subscription";


@Component({
  selector: 'dashboard',
  templateUrl: 'dashboard.html'
})
@LoginRequired()
export class Dashboard implements ViewDidEnter {

  @ViewChild('postListNav') postListNav: NavController;
  @ViewChild(Content) container: Content;
  
  headerBarMobileTitle = 'dashboard';
	headerBarMobileTemplate = 'avatar-and-plus';
  headerBarMobileTitleContext: any = null;
  headerBarMobileTitlePrevious = '';
  
  private scrollToTopSubscription: Subscription;

  constructor(public authService: AuthService,
              private nav: NavController,
              private eventService: EventService,
              private pageTitleService: PageTitleService,
              private navigationHelper: NavigationHelper,
              private ionic: IonicHelper,
              public userGroupService: UserGroupService) {
  }

  ionViewDidEnter(): void {
    		
		if(this.postListNav){
		  
		  if(this.postListNav.getActive()) {
		    this.fixUrl();
      }
		  
		  this.postListNav.viewDidEnter.subscribe((controller: ViewController) => {
		    this.fixUrl();        	
			});
		  
    }
    
    
    this.scrollToTopSubscription = this.eventService.scrollToTop.subscribe(() => {
      this.container.scrollToTop();
    });
		
	}
	
	public propagatePageTitle(key, params: any = null){
      this.pageTitleService.setPageTitle(key, params);
      this.headerBarMobileTitle = key;
      this.headerBarMobileTitleContext = params;    
  }
	
	private fixUrl(){
    
    if(this.postListNav && this.postListNav.getViews().length && this.postListNav.getViews()[0].instance instanceof PostListContainer) {
      let postListPath = this.postListNav.getViews()[0].instance.currentPath;
      this.navigationHelper.updateLocation(postListPath, 'dashboard', {}, 'back');
    }
		    
  }

  public setMobileHeaderTemplate($event): void{
		if($event){
			this.headerBarMobileTitlePrevious = this.headerBarMobileTitle;
			this.headerBarMobileTemplate = 'new-post';
			this.headerBarMobileTitle = 'new-post';
		}
		else{
			this.headerBarMobileTemplate = 'avatar-and-plus';
			this.headerBarMobileTitle = this.headerBarMobileTitlePrevious;
		}
	}

  
}



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.ts